import {
	ESourceTypes,
	getBloggerUrls,
	IArbitrageForm,
	IBloggerForm,
	IBloggerUrl,
	ISource,
	IWebsiteForm,
	TCreateSourceRequest,
} from 'entities/Source';

export const prepareWebsiteSourceData = (source: ISource): IWebsiteForm => {
	return {
		...source.website_data,
		name: source.name,
	};
};

export const prepareBloggerSourceData = (source: ISource): IBloggerForm => {
	const values = {
		...source.influencer_data,
		name: source.name,
	};

	const urls = prepareBloggerUrls(source.influencer_data.urls);

	Object.keys(urls).forEach((type) => {
		urls[type].forEach((url, key) => {
			values[`${type}_url_${key}` as keyof IBloggerForm] = url as string & string[];
		});
	});

	return values;
};

export const prepareBloggerUrls = (urls: IBloggerUrl[]): Record<string, string[]> => {
	return urls.reduce(
		(acc, url) => {
			return {
				...acc,
				[url.platform_type]: [...(acc[url.platform_type] || []), url.url],
			};
		},
		{} as Record<string, string[]>,
	);
};

export const prepareArbitragerSourceData = (source: ISource): IArbitrageForm => {
	return {
		...source.arbitrage_data,
		url1: source.arbitrage_data.urls[0]?.url,
		url2: source.arbitrage_data.urls[1]?.url,
		url3: source.arbitrage_data.urls[2]?.url,
		url4: source.arbitrage_data.urls[3]?.url,
		url5: source.arbitrage_data.urls[4]?.url,
		urls: source.arbitrage_data.urls.map((_, i) => (i + 1 + '') as '1'),
		name: source.name,
	};
};

export const prepareCreateWebsiteData = (values: IWebsiteForm, type: ESourceTypes): Partial<TCreateSourceRequest> => {
	return {
		type,
		name: values.name,
		url: values.url,
		website_data: {
			...values,
			url: values.url,
			platform_type: values.platform_type || '',
			extension_description: values.extension_exists ? values.extension_description : '',
		},
	};
};

export const prepareCreateBloggereData = (
	values: IBloggerForm,
	type: ESourceTypes,
	bloggerUrls: Record<string, string[]>,
): Partial<TCreateSourceRequest> => {
	return {
		type,
		name: values.name,
		influencer_data: {
			...values,
			urls: getBloggerUrls(bloggerUrls, values.platform_types),
		},
	};
};

export const prepareCreateArbitrationData = (
	values: IArbitrageForm,
	type: ESourceTypes,
	arbitrationValues: IArbitrageForm,
): Partial<TCreateSourceRequest> => {
	return {
		type,
		name: values.name,
		arbitrage_data: {
			...values,
			purchase_type: values.purchase_type,
			urls: arbitrationValues.urls.filter((key) => values[`url${key}`]).map((key) => ({ url: values[`url${key}`] })),
			screenshots: arbitrationValues.screenshots,
		},
	};
};
